import { createRoot } from "react-dom/client";
import React from "react";
import * as Mod from "./server-app.jsx";

// Find the App component however it's exported. Tries (in order):
//   1. default export
//   2. any named export that looks like a React component (capitalized fn name)
function findApp() {
  if (typeof Mod.default === "function") return Mod.default;
  for (const [k, v] of Object.entries(Mod)) {
    if (typeof v === "function" && /^[A-Z]/.test(k)) return v;
  }
  return null;
}
const App = findApp();

if (!App) {
  const exportNames = Object.keys(Mod).join(", ") || "(none)";
  document.getElementById("root").innerHTML =
    '<div style="padding:24px;font-family:sans-serif;color:#c0392b"><b>Build error:</b> no React component export found in server-app.jsx.<br/>Exports seen: ' + exportNames + '</div>';
  console.error("[SS] No App found. Exports:", Object.keys(Mod));
} else {
  console.log("[SS] Mounting App component:", App.name || "(anonymous)");
  createRoot(document.getElementById("root")).render(<App />);
}
